export const MENUBAR_DATA_MOCK = [
    {
        id: 0,
        title: 'Requesting',
        value: 'REQUEST',
        link: '/request',
    },
    {
        id: 1,
        title: 'Supporting',
        value: 'SUPPORT',
        link: '/support'
    },
]